import React, { memo } from "react";
export default memo(({ page, onClick, isCurrent }) => (
  <li>
    <a
      {...{
        className: isCurrent ? "pagination-link is-current" : "pagination-link",
        onClick: isCurrent ? undefined : onClick(page)
      }}
    >
      {page}
    </a>
  </li>
));
